module.exports = ".rm-grid-row:hover {\n  background-color: yellow !important;\n  background-color: aqua !important; }\n\n.rm-grid-cell:focus {\n  border: none !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reimbursements/reimbursements.component.scss
// module id = ./src/app/reimbursements/reimbursements.component.scss
// module chunks = main